// extracted by mini-css-extract-plugin
module.exports = {"Risk":"Risk_Risk__t3ZgR","isAu":"Risk_isAu__ZZaY0"};